import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IDependency } from '../../../stores/model/metamodel/dependency';

/**
 * Check if a dependency is consistent.
 *
 * Checks if:
 * - master and dependent are different
 */
class DependencyConsistencyCheck extends Check<IDependency> {
  static description = 'Check for dependency consistency';

  check(): Report {
    this.report = new Report();

    // Old code checked if master.getDependencies().contains(subject) and
    // similar for dependent. The internal model state is now setup in a way
    // that such inconsistencies cannot exist.

    // Similarly, we don't have to check for missing master, dependent or type
    // because it is not possible to create a dependency without them.

    if (this.element.master === this.element.dependent) {
      this.report.addMessage(
        MessageType.ERROR,
        'The master and dependent cannot be equal.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'Dependency variables are set correctly',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default DependencyConsistencyCheck;
